<template>
    <transition name="custom-collapse-transition">
      <div v-show="open" :id="id" class="custom-collapse" :style="{ maxHeight: open ? contentHeight : '0px' }">
        <slot></slot>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        contentHeight: '0px'
      };
    },
    mounted() {
      if (this.open) {
        this.$nextTick(() => {
          this.contentHeight = `${this.$el.scrollHeight}px`;
        });
      }
    },
    watch: {
      open(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.contentHeight = `${this.$el.scrollHeight}px`;
          });
        } else {
          this.contentHeight = '0px';
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .custom-collapse {
    overflow: hidden;
    overflow-y: auto;
    transition: max-height 0.3s ease;
  }
  
  .custom-collapse-transition-enter-active,
  .custom-collapse-transition-leave-active {
    transition: max-height 0.3s ease;
  }
  
  .custom-collapse-transition-enter,
  .custom-collapse-transition-leave-to {
    max-height: 0;
    opacity: 0;
  }
  </style>
  